import {observer} from 'mobx-react';
import React from 'react';
import {userStatusService} from '../domain';
import {routerStore} from '../lib/components';
import {NotFoundScene} from '../scenes/NotFoundScene';
import {routeEntries} from './RouterConfig';

@observer
export class ContentBlock extends React.Component {
  render() {
    const path = routerStore.path;
    const userStatus = userStatusService.status;

    for (let entry of routeEntries) {
      let match = entry.matcher.match(path);
      if (!match.matches)
        continue;
      const provided = {userStatus: userStatus, route: path, params: match.params};
      return entry.renderFn(provided);
    }

    return <NotFoundScene/>;
  }
}
